import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IUpdatePaperGoodsIssue } from "mobx-stores/_models/paper-inventory/paper-goods-issue/paper-goods-issue";
import { date } from "yup";
import { getGoodsIssueItemsArraySchema } from "../goods-issue-schema-shared";

export const getUpdatePaperGoodsIssueSchema =
  (): ObjectSchemaType<IUpdatePaperGoodsIssue> => ({
    id: {
      type: InputType.none,
    },
    issueDate: {
      type: InputType.datePicker,
      gridSize: 12,
      label: "Ngày nhập",
      validattionYupSchema: date().required(),
    },

    items: {
      arraySchema: {
        id: {
          type: InputType.none,
          defaultValue: "",
        },
        ...getGoodsIssueItemsArraySchema(),
      },
    },
  });
